<template>
  <div>
    <section class="critter-list">
      <creator-detail v-for="creator in creators" :key="creator" :creator="creator"></creator-detail>
    </section>
  </div>
</template>

<script>
import CreatorDetail from './CreatorDetail.vue';

export default {
  computed: {
    creators() {
      return this.$store.state.creators;
    }
  },
  components: {
    CreatorDetail
  }
}
</script>


// WEBPACK FOOTER //
// CreatorList.vue?3be33cdc